import {z} from 'zod';

export const ShareLinkAssetSchema = z.object({
	attributes: z.array(
		z.union([
			z.null(),
			z.number(),
			z.string(),
			z.array(z.union([z.number(), z.string(), z.null()])),
		]),
	),
	/** ex: 2020-11-09T14:35:03 */
	creationDate: z.string(),
	/** milliseconds */
	duration: z.number().int().positive(),
	fileSize: z.number(),
	/** asset id */
	id: z.number().int(),
	/** ex: 2020-11-09T14:35:03 */
	importDate: z.string(),
	/** ex: 2020-11-09T14:35:03 */
	modDate: z.string(),
	name: z.string(),
	fileFormatFamily: z.array(z.string()),
	fileHeight: z.number().int().positive(),
	fileName: z.string(),
	fileWidth: z.number().int().positive(),
	fileTypeLabel: z.string(),
	pageCount: z.number().int().positive(),
	/** path */
	preview: z.string(),
	previewHeight: z.number().int().positive(),
	previewWidth: z.number().int().positive(),
	status: z.number(),
	/** path */
	thumb: z.string(),
	viewNames: z.array(z.string()),
	/** path */
	zoom: z.string(),
	jwt: z.string().nullable(),
});

export const ShareLinkAssetField = ShareLinkAssetSchema.keyof().enum;

export type IShareLinkAsset = z.infer<typeof ShareLinkAssetSchema>;
